export const CLICK_AND_COLLECT = 'ClickAndCollect';
export const PARTNERSHIP_STORE = 'PartnershipStore';
export const COLLECT_PLUS = 'CollectPlus';
export const FILTER_COLLECT_PLUS = 'FILTER_COLLECT_PLUS';
export const VIEW_TYPE_LIST = 'search-list';
export const VIEW_TYPE_MAP = 'search-map';
export const STORE_SELECTED = 'store-selected';
export const STORE_DETAILS = 'store-details';
export const JOHN_LEWIS_OWNER_ID = 1;
export const WAITROSE_OWNER_ID = 2;
export const COLLECT_PLUS_OWNER_ID = 3;
export const BOOTHS_OWNER_ID = 4;
export const COOP_OWNER_ID = 5;
